import getWebEnv from 'web/env';

const localStorageKey = getWebEnv().REACT_APP_SETTINGS_KEY;

export const getLocalStorageState = (key, defaultValue) => {
	const storedSettings = localStorage.getItem(localStorageKey);
	let parsedSettings = {};

	if (storedSettings) {
		try {
			parsedSettings = JSON.parse(storedSettings);
		} catch (error) {
			console.warn(
				'Invalid JSON in localStorage, resetting settings:',
				error
			);
			// Clear the corrupted data
			localStorage.removeItem(localStorageKey);
			parsedSettings = {};
		}
	}

	return key in parsedSettings ? parsedSettings[key] : defaultValue;
};

export const setLocalStorageState = (key, value) => {
	const storedSettings = localStorage.getItem(localStorageKey);
	let parsedSettings = {};

	if (storedSettings) {
		try {
			parsedSettings = JSON.parse(storedSettings);
		} catch (error) {
			console.warn(
				'Invalid JSON in localStorage, resetting settings:',
				error
			);
			// Clear the corrupted data and start fresh
			localStorage.removeItem(localStorageKey);
			parsedSettings = {};
		}
	}

	const updatedSettings = {
		...parsedSettings,
		[key]: value,
	};

	localStorage.setItem(localStorageKey, JSON.stringify(updatedSettings));
};
